import React, { ReactElement } from 'react'
import { Box, Button } from '@mui/material'
import { DeleteIcon, EditIcon } from 'src/v3/core/icons'
import { AccreditationStatus } from '../../shared-types'

type StatusActionsProps = {
  status: AccreditationStatus
  submitting: boolean
  onEdit: () => void
  onDelete: () => void
  onFinalize: () => void
}

export let StatusActions = ({
  status,
  submitting,
  onEdit,
  onDelete,
  onFinalize,
}: StatusActionsProps): ReactElement => {
  // Approved status shows only Finalize button
  if (status === 'Approved') {
    return (
      <Box className="flex justify-end gap-2 mt-6">
        <Button
          color="primary"
          variant="contained"
          size="small"
          onClick={onFinalize}
          disabled={submitting}
        >
          {submitting ? 'Finalizing...' : 'Finalize'}
        </Button>
      </Box>
    )
  }

  // All other statuses (Draft, Submitted, Rejected) show Edit + Delete
  return (
    <Box className="flex justify-end gap-2 mt-6">
      <Button
        startIcon={<EditIcon />}
        size="small"
        onClick={onEdit}
        disabled={submitting}
      >
        Edit
      </Button>
      <Button
        color="error"
        size="small"
        startIcon={<DeleteIcon />}
        onClick={onDelete}
        disabled={submitting}
      >
        Delete
      </Button>
    </Box>
  )
}
